// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"182":"8b23efac","312":"8b23efac","393":"8b23efac","627":"6469d025","682":"6469d025","997":"8b23efac"}[chunkId] + ".chunk.css";
};